import { CREATE_ORGANIZATION_ERROR } from './actionTypes';

const initialState = {
  loadingNewOrganization: false,
};

const newOrganizationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CREATE_ORGANIZATION_ERROR:
      return {
        ...state,
        error: action.error,
        loadingNewOrganization: false,
      };
    default:
      return state;
  }
};

export default newOrganizationReducer;
